import { render } from "./PledgeManagerInfoPromoBannerBox.vue?vue&type=template&id=6e6366a8"
import script from "./PledgeManagerInfoPromoBannerBox.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoPromoBannerBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__